import { useState, useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';
import {
    RING_MEASUREMENT_TYPE_PARAM,
    CURRENCY_USD,
    RING_SIZE_US,
    RING_SIZE_MM,
    type RingSize,
} from '../../../constants/ringSize.ts';

import { type useRingMeasurementType_itemSearch$key } from './__generated__/useRingMeasurementType_itemSearch.graphql.ts';
import { useAppliedFilterUrlLabel } from '../../helpers/appliedFilters/useAppliedFilterUrlLabel.ts';

const itemSearchFragment = graphql`
    fragment useRingMeasurementType_itemSearch on ItemSearchQueryConnection {
        ...useAppliedFilterUrlLabel_itemSearch
    }
`;

export function useRingMeasurementType({
    currency,
    itemSearch: itemSearchRef,
}: {
    currency: string;
    itemSearch: useRingMeasurementType_itemSearch$key;
}): RingSize {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const appliedFilterUrlLabel = useAppliedFilterUrlLabel(itemSearch, RING_MEASUREMENT_TYPE_PARAM);

    const appliedFilterRingSize = appliedFilterUrlLabel?.toUpperCase() as RingSize | undefined;
    const defaultRingMeasurementType = currency === CURRENCY_USD ? RING_SIZE_US : RING_SIZE_MM;
    const ringSize = appliedFilterRingSize || defaultRingMeasurementType;

    const [ringMeasurementType, setRingSizeUnit] = useState<RingSize>(ringSize);

    useEffect(() => {
        setRingSizeUnit(ringSize);
    }, [ringSize]);

    return ringMeasurementType;
}
